module.exports = __webpack_public_path__ + "img/hindii-lang.e02d7af1.svg";